







import TreatmentMonitoringListMobile from "../mobile/treatment-monitoring/TreatmentMonitoringListMobile.vue";
import TreatmentMonitoringList from "./TreatmentMonitoringList.vue";
import ResponsiveLayout from "../../mixin/ResponsiveLayout.vue";

export default {
  components: {
    ResponsiveLayout,
    TreatmentMonitoringListMobile,
    TreatmentMonitoringList,
  },
  data() {
    return {
      TreatmentMonitoringList,
      TreatmentMonitoringListMobile,
    };
  },
};
